import { OrgLogoContainer, DisplayName, TeamScore, ByeTBD } from "./styles";
import { selectRosterDisplayName } from "selectors/Roster";
import { CenterFlexColumn } from "styles/layout";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { useAppSelector } from "app/hooks";
import { isPlaceholderRosterId } from "model/Roster/Roster";

interface Props {
  rosterId: string;
  tournamentId: string;
  scoreString: string;
}

export const MatchViewerRowedTeam = ({
  rosterId,
  tournamentId,
  scoreString,
}: Props) => {
  const displayName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterId, tournamentId)
  );

  if (isPlaceholderRosterId(rosterId)) {
    return <ByeTBD>{displayName}</ByeTBD>;
  }

  return (
    <CenterFlexColumn>
      <OrgLogoContainer>
        <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
      </OrgLogoContainer>
      <DisplayName>{displayName}</DisplayName>
      <TeamScore>{scoreString}</TeamScore>
    </CenterFlexColumn>
  );
};
